import { Typography } from '@mui/material';
import type { AuditLog } from '@repo/api-gw-sdk';
import type { Row } from '@tanstack/react-table';
import { useState } from 'react';

import CopyToClipboardButton from '@/components/buttons/copyToClipboardButton';
import MainDialog from '@/components/dialogs/mainDialog';
import { JsonViewer } from '@/components/shared/jsonViewer';

export const AuditLogOperationCell = ({ row }: { row: Row<AuditLog> }) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = () => {
    setIsOpen(true);
  };

  return (
    <>
      <Typography
        variant='subtitle1'
        className='underline hover:cursor-pointer hover:text-[var(--mui-palette-text-gray1)]'
        onClick={handleClick}
      >
        {row.original.operationName}
      </Typography>
      <AuditLogJsonViewer
        data={row.original}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};

const AuditLogJsonViewer = ({
  data,
  isOpen,
  onClose,
}: {
  data: AuditLog;
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <MainDialog
      isOpen={isOpen}
      isLoading={false}
      header={{
        title: `Audit log parameters - ${data.operationName}`,
        onClose,
      }}
      footer={{
        primaryButton: {
          text: 'Close',
          onClick: onClose,
          'data-testid': 'close-audit-log-json-viewer',
        },
        children: (
          <CopyToClipboardButton
            textToCopy={JSON.stringify(data)}
            buttonLabel='Copy'
          />
        ),
      }}
    >
      <JsonViewer data={data} />
    </MainDialog>
  );
};
